// Imports
import { Base, DataTypes, SubmitTypes, ErrorTypes } from '@mixins/forms'
import HsiaLoginMixin from '@mixins/hsia-login-mixin'
import { transform } from 'lodash'

// Parts
const { ObjectDataType: dataType } = DataTypes
const { AuthSubmit: submitType } = SubmitTypes
const { AccountError: errorHandling } = ErrorTypes

// Options
const options = {
  name: 'fmo:join',
  dataType,
  submitType,
  errorHandling,
  submitOnChange: false,
  skipValidation: false,
  tracking: {
    view: true,
    validation: true,
    externalValidation: true,
    submit: {},
    error: true
  }
}

// Component
export default {
  name: 'registration-form',
  mixins: [
    Base(options),
    HsiaLoginMixin
  ],
  props: {
    source: {
      type: String,
      default: 'global'
    }
  },
  data: () => ({
    parsedFormSourceParam: new URL(window.location.href).searchParams.get('source'),
	  grecaptchaToken: '',
    grecaptchaReady: false
  }),
  computed: {
    authType() {
      return 'register'
    },
    innerScope() {
      return {
        grecaptchaCallback: this.grecaptchaCallback,
        grecaptchaExecute: this.grecaptchaExecute,
        grecaptchaToken: this.grecaptchaToken,
        grecaptchaReady: this.grecaptchaReady,
        grecaptchaReadyCallback: this.grecaptchaReadyCallback
	  }
	}
  },
  methods: {
    extendSubmitTracking(data) {
      return {
        event: 'fomoSignup',
        events: {
          newsletterSignup: data?.profile?.newsletter ?? false
        },
        user: {
          accountNumber: data?.profile?.fanId?.toLowerCase(),
          accountType: data?.profile?.loyalLevel,
          loginState: 'logged in',
          ireckonuID: data?.profile?.personId?.toString() || null
        },
        registration: {
          source: this.source ? this.source : this.parsedFormSourceParam !== null ? this.parsedFormSourceParam : ''
        }
      }
    },
    async transformData(data) {
      return {
        ...data,
        source: this.source ? this.source : this.parsedFormSourceParam !== null ? this.parsedFormSourceParam : '',
		    grecaptchaCallback: this.grecaptchaCallback,
        grecaptchaExecute: this.grecaptchaExecute,
        grecaptchaToken: this.grecaptchaToken,
        grecaptchaReady: this.grecaptchaReady,
        grecaptchaReadyCallback: this.grecaptchaReadyCallback
      }
    },
    grecaptchaCallback(token) {
      this.grecaptchaToken = token
      this.$nextTick(() => {
        this.form.submit()
      });
    },
    grecaptchaReadyCallback() {
      this.grecaptchaReady = true
    },
    grecaptchaExecute() {
      this.$root.$emit('grecaptcha-execute')
    }
  }
}
